export const roles = {
  ROLE_ADMIN: "ROLE_ADMIN",
  ROLE_WATCHER: "ROLE_WATCHER",
  ROLE_SUPPORT: "ROLE_SUPPORT",
  ROLE_ANALYZER: "ROLE_ANALYZER",
};
